import styled from 'styled-components';
import colors from 'styles/colors';
import media from 'styles/media';

const CloseButtonContainer = styled.div`
  display: flex;
  justify-content: end;
  padding: 27px 35px;

  path {
    stroke: ${colors.primary.ocean};

    ${media.small`
      stroke: ${colors.primary.ice};
    `}
  }

  svg {
    width: 20px;
    height: 20px;
  }

  ${media.small`
    position: relative;
    padding: 0;

    button {
      position: absolute;
      transform: translateX(0);
      right: 0;
      top: 20px;
      z-index:2
    }
  `}
  ${media.medium`
    position: relative;
    padding: 0;
    padding-right: 40px;

    button {
      position: absolute;
      transform: translateX(0);
      right: -50;
      top: 20px;
      z-index:2
    }
  `}
`;

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0);
  pointer-events: none;
`;

const ScrollingComponent = styled.div`
  height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  padding-bottom: 50px;
`;

const SideBar = styled.div`
  background: ${colors.primary.ice};
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  transform: translateX(-350px);
  width: 350px;
  ${media.small`    
    transform: translateX( calc(-1 * calc(100vw - 30rem) )   );
    width: calc(100vw - 30rem); 
    max-width: 350px;   
  `}
`;

const SideBarLanguageSelector = styled.a`
  display: none;

  ${media.medium`
    display: block;
    border-top: solid 1px ${colors.functional.middleGray};
    margin: 0 24px 40px 24px;
    position: relative;
    top: 0px;
    height: 200px;
  `}
`;

const TextContainer = styled.span`
  margin-left: 16px;
  font-size: 12px;
  letter-spacing: 2px;
`;

const Ul = styled.ul`
  margin-bottom: 20px;
  position: relative;

  transform: translateX(0px);
  width: 350px;

  ${media.small`
    width: calc(100vw - 30rem);
  
  `}

  a {
    display: block;
    color: ${colors.primary.ocean};
    font-size: 22px;
    ${media.medium`
      font-size: 20px;
    `}
    height: 65px;
    line-height: 65px;
    padding-left: 60px;
    position: relative;

    ${media.medium`
      padding-left: 24px;
    `}

    :hover {
      background-color: ${colors.functional.lightGrey};
    }

    & svg {
      height: 16px;
      position: absolute;
      right: 49px;
      top: 23px;
      width: 16px;

      path {
        stroke: ${colors.primary.ocean};
      }
    }
  }

  li {
    &.mobileSignIn {
      display: none;

      a {
        font-size: 14px;
        letter-spacing: 2px;
      }

      ${media.medium`
        display: block;
      `}
    }

    ul {
      position: absolute;
      top: 0;

      width: 350px;
      right: -350px;
      ${media.small`
        width: calc(100vw - 30rem);
       
      `}

      &.show {
        display: block;
      }

      .backToMain {
        font-size: 18px;

        ${media.medium`
          padding-left: 60px;
        `}

        svg {
          left: 20px;
          transform: rotate(180deg);
          right: inherit;
        }
      }

      li:nth-child(2) {
        font-weight: 800;
      }

      ${media.medium`
        top: 0px;
      `}
    }
  }
`;

const MenuToolBar = styled.div`
  align-items: center;
  display: flex;
  position: relative;
  transform: translateX(0px);
  color: ${colors.primary.ocean};
  font-size: 14px;
  letter-spacing: 0.3rem;
  ${media.small`
  font-size: 14px;
  `}
  ${media.medium`
    font-size: 14px;
  `}
  height: 65px;
  line-height: 15px;
  margin: 12px 0px 20px;
  padding: 0px 16px 12px 60px;
  position: relative;

  ${media.medium`
    padding-left: 24px;
  `}

  :hover {
    background-color: ${colors.functional.lightGrey};
  }
`;

const Wrapper = styled.div`
  position: relative;
  z-index: 1;
`;

const ImgCAS = styled.img`
  width: 27px;
  height: 30px;
  margin-right: 14px;
`;

const MenuLink = styled.a`
  align-items: center;
  display: flex;
  text-transform: uppercase;
  width: 85%;
`;

const TierText = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  width: 85%;
  white-space: nowrap;
`;

const Styles = {
  CloseButtonContainer,
  Overlay,
  SideBar,
  SideBarLanguageSelector,
  ScrollingComponent,
  TextContainer,
  Ul,
  Wrapper,
  MenuToolBar,
  ImgCAS,
  MenuLink,
  TierText,
};

export default Styles;
